// https://vuex.vuejs.org/en/mutations.html

export default {
    retrieveToken(state, token) {
        state.token = token;
    },
    setRole(state, role) {
        state.role = role;
    },
    setIsParish(state, isParish) {
        state.isParish = isParish;
    },
    destroyToken(state) {
        state.token = null;
    },
    destroyRole(state) {
        state.role = null;
    },
    setError(state, error) {
        state.error = error;
    },
    setUserLocations(state, locations) {
        state.userLocations = locations;
    },
    setLastLocation(state, location) {
        state.lastLocation = location;
    },
    setHasDelegations(state, hasDelegations) {
        state.hasDelegations = hasDelegations;
    }
};
